import { CreateExtensionInterface } from "../interfaces/ExtensionInterface/CreateExtensionInterface";
import { ExtensionInterface } from "../interfaces/ExtensionInterface/ExtensionInterface";
import BaseService from "./BaseService";

export class ExtensionService extends BaseService<ExtensionInterface, CreateExtensionInterface>{ 
    constructor(){
        let url: string = '/extension/admin'
        super(url)
    }
}